import React from "react";
import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { QRCodeCanvas } from "qrcode.react";

export default function AttendeesQrCodeDialog({
  open,
  onClose,
  eventName,
  qrCodeUrl,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
      <div className="fixed inset-0 flex w-screen items-center justify-center">
        <DialogPanel className="w-96 border bg-white rounded-lg p-8">
          <DialogTitle className="font-medium text-lg text-[#5057FF] text-center pt-4">
            {eventName} <span className="text-gray-800">Combine</span>
          </DialogTitle>
          <Description>
            <div className="flex items-center justify-center">
              <QRCodeCanvas value={qrCodeUrl} size={250} className="p-4" />
            </div>
          </Description>
          <p className="text-center mt-0 text-base text-gray-600">
            Scan the QR code to register
          </p>
          <div className="flex gap-4 pt-6 items-center justify-center">
            <button onClick={onClose}>Cancel</button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
